// extracted by mini-css-extract-plugin
export default {"button":"button___VPRfq","brandTextWrap":"brandTextWrap___N6eFJ","openModalIcon":"openModalIcon___mC9yc"};